import webApi from "../WebApi/WebApi";

export const getTotalVoucherEntryStatus = async (dist, block, gp, report) => {
    return await webApi.get(`/MIS/TotalVoucher?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}`,);
}
